module.exports = __webpack_public_path__ + "img/NoDataFound.63a6dfcc.svg";